import API from '.';

export default class UnprocessedLocation {
  /**
   * The UnprocessedLocation dimension table for UDM
   * @param {number} locationId Id of the location.
   * @param {string} destination destination of the location.
   * @param {date} createdOn Date of creation of the log.
   * @param {date} processeddOn Date of process of the log.
   */
  constructor({
    locationId,
    destination,
    connexion,
    createdOn,
    processedOnConnexion
  }) {
    if (locationId) {
      this.locationId = locationId;
      this.destination = destination;
      this.Connexion = connexion;
      this.createdOn = createdOn;
      this.processedOnConnexion = processedOnConnexion;
    }
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/admin/unprocessedlocation');
    return data.map((d) => new UnprocessedLocation(d));
  }

  static async get(locationId) {
    const api = await API();
    if (locationId) {
      const { data } = await api.get(`unprocessedlocation/locationId/${locationId}`);
      if (data) {
        return new UnprocessedLocation(data);
      }
    }
    return null;
  }
}
